import React from "react";
import PolicesListPageContainer from "./PolicesListPageContainer";

export class PolicesListPage extends React.Component {
  render() {
    return <PolicesListPageContainer {...this.props} />;
  }
}
